import { IUpdatePgtoContratoFinanceiroUseCase } from "../../../presentation/useCases/update/update_pgto_contrato_financeiro_use_case";
import { IFinanceiroRepository } from "../../repositories/financeiro_repositories";

/**
 * UpdatePgtoContratoFinanceiroUseCase
 */

export class UpdatePgtoContratoFinanceiroUseCase implements IUpdatePgtoContratoFinanceiroUseCase {
  constructor(private readonly repository: IFinanceiroRepository) { }

  async updatePgtoContratoFinanceiro(
    idPgtoContratofinanceiro: number,
    observacao?: string | null,
    valorReceber?: number | null,
    dataReceber?: Date | null,
    tipo?: number | null
  ): Promise<void> {
    await this.repository.updatePgtoContratoFinanceiro(
      idPgtoContratofinanceiro,
      observacao,
      dataReceber,
      valorReceber,
      undefined,
      tipo
    );
  }
}
